import React from 'react'
import { useTheme } from 'styled-components'

import { IconComponent } from '@application/Interfaces/Icons/types'
import { Theme } from '@application/Interfaces/Themes/ThemeType'

export const DoubleQuoteIcon: IconComponent = ({ className, colorCode = 'g100', width = 100, height = 89 }) => {
    const theme = useTheme() as Theme
    const color = theme.color[colorCode]

    return (
        <svg
            className={className}
            width={width}
            height={height}
            viewBox="0 0 100 89"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M40.1739 17.5086C42.6747 16.4599 43.7234 13.4751 42.594 11.0549L38.6412 2.74588C37.5118 0.407242 34.769 -0.642282 32.3489 0.407242C25.4919 3.31138 19.6029 7.1029 14.924 11.7011C9.19644 17.1052 5.32425 23.3169 3.22682 30.1739C1.12939 37.1123 0 46.55 0 58.5699V83.3358C0 85.9979 2.1781 88.176 4.84023 88.176H36.5438C39.2059 88.176 41.384 85.9979 41.384 83.3358V51.6322C41.384 48.9693 39.2059 46.792 36.5438 46.792H21.3777C21.539 38.6435 23.4751 32.11 27.0246 27.1882C29.9288 23.237 34.285 20.0102 40.1739 17.5086Z"
                fill={color}
            />
            <path
                d="M97.1265 17.5086C99.6273 16.4599 100.675 13.4751 99.5466 11.055L95.5937 2.82738C94.4643 0.487936 91.7215 -0.560781 89.3014 0.487936C82.5251 3.39207 76.716 7.18359 71.9573 11.7011C66.2288 17.1867 62.2768 23.3984 60.1785 30.2554C58.0811 37.0309 57.0332 46.4701 57.0332 58.5707V83.3366C57.0332 85.9987 59.2113 88.1768 61.8734 88.1768H93.577C96.2391 88.1768 98.4172 85.9987 98.4172 83.3366V51.633C98.4172 48.9701 96.2391 46.7928 93.577 46.7928H78.3302C78.4916 38.6443 80.4285 32.1108 83.9772 27.1891C86.8813 23.237 91.2375 20.0102 97.1265 17.5086Z"
                fill={color}
            />
        </svg>
    )
}
